import * as React from "react";
import {
  PanaceaMobile,
  Clickatell
} from "app/components/AppComponents/SmsProvider";
import PosConsoleApi from "app/utils/PosConsoleApi";

export default class Overview extends React.Component<any, {}> {
  state = {
    isLoading: true,
    clickatell: {},
    panacea: {}
  };

  componentDidMount() {
    this.props.setHeader({
      title: "Ops > SMS > Overview",
      description: "SMS Provider Overview"
    });

    PosConsoleApi.get("text_messages/status")
      .then(response => response.json())
      .then(({ clickatell, panacea }) => {
        this.setState({
          clickatell,
          panacea,
          isLoading: false
        });
      });
  }

  render() {
    const { clickatell, panacea, isLoading } = this.state;
    return (
      <section id="providersContainer" className="padded">
        {isLoading ? (
          <div>Loading...</div>
        ) : (
          <>
            <PanaceaMobile stats={panacea} />
            <Clickatell stats={clickatell} />
          </>
        )}
      </section>
    );
  }
}
